import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { INPUT_MIN_WIDTH } from '../../constants.js';
import { getResponsiveSx } from '../../utils/styleHelpers.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var inputContainerBaseSx = {
  pos: "relative",
  minw: INPUT_MIN_WIDTH,
  flexShrink: 0,
  gap: "0px",
  "& > *": {
    pos: "absolute"
  }
};
var sideContainerSx = {
  top: "50%",
  transform: "translateY(-50%)"
};
var leftContainerSx = {
  left: "base.spacing.x3",
  pointerEvents: "none"
};
var rightButtonsContainerSx = {
  right: "base.spacing.x3"
};
var clearValueButtonSx = {
  mx: function mx(_ref) {
    var base = _ref.base;
    return "calc(".concat(base.spacing.x1, " * -1)");
  },
  pointerEvents: "auto"
};
var baseInputSx = {
  appearance: "none",
  w: "100%",
  h: "100%",
  border: "none",
  brad: "base.borderRadius.x4",
  fontFamily: "base.font.family.body.primary",
  fontSize: "base.text.body.medium.regular.fontSize",
  lineHeight: "base.text.body.medium.regular.lineHeight",
  fontWeight: "base.text.body.medium.regular.fontWeight",
  c: "base.color.text.body.primary",
  transitionProperty: "box-shadow, background",
  transitionDuration: "base.motion.normal.fast.cssDuration",
  transitionTimingFunction: "base.motion.normal.fast.cssEase",
  "&:not(:disabled):hover": {
    bgc: "base.color.translucent.emphasis.200"
  },
  "&:not(:disabled):focus": {
    bgc: "base.color.translucent.emphasis.300"
  },
  "&:-webkit-autofill": {
    backgroundClip: "text",
    textFillColor: "base.color.text.body.primary",
    // @NOTE: the below seems to disable webkit autofill bg color styles
    transition: "background-color 5000s ease-in-out 0s"
  }
};
var inputIconBaseSx = {
  // @NOTE: dont abbreviate these 2 rules - as doing so can conflict
  // with the sizing of Select.Option.FramedImage and Select.DefaultFramedImage
  // (which are sized responsively, using "width" & "height", not "w" and "h")
  width: "base.icon.size.300",
  height: "base.icon.size.300",
  // ----------------------------------------------------------
  bg: "transparent",
  fill: "base.color.text.body.primary",
  left: "base.spacing.x3"
};
var adornmentSx = {
  c: "base.color.text.body.primary",
  lineHeight: "unset"
};
function renderInputSx(_ref2) {
  var validationStatus = _ref2.validationStatus,
    leftHandButtonsWidth = _ref2.leftHandButtonsWidth,
    rightHandButtonsWidth = _ref2.rightHandButtonsWidth,
    textAlign = _ref2.textAlign,
    theme = _ref2.theme,
    hasValue = _ref2.hasValue;
  var paddingLeft = leftHandButtonsWidth > 0 ? "calc(".concat(leftHandButtonsWidth, "px + ").concat(theme.base.spacing.x5, ")") : theme.base.spacing.x3;
  var paddingRight = rightHandButtonsWidth > 0 ? "calc(".concat(rightHandButtonsWidth, "px + ").concat(theme.base.spacing.x5, ")") : theme.base.spacing.x3;
  var hoverShadow = theme.base.shadow[300];
  var focusShadow = theme.base.shadow[200];
  var emptyShadow = "0 0 0 rgba(0,0,0,0)";
  return {
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    textAlign: textAlign,
    background: hasValue ? theme.base.color.translucent.emphasis[200] : theme.base.color.translucent.emphasis[100],
    boxShadow: validationStatus === "error" ? "".concat(emptyShadow, ", inset 0 0 0 ").concat(theme.base.border.size[100], " ").concat(theme.base.color.status.fatal.bright) : hasValue ? "".concat(emptyShadow, ", inset 0 0 0 ").concat(theme.base.border.size[100], " ").concat(theme.base.color.translucent.standard[800]) : "".concat(emptyShadow, ", inset 0 0 0 ").concat(theme.base.border.size[100], " ").concat(theme.base.color.translucent.standard[500]),
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      // @NOTE: this hides the up and down arrows on number inputs
      display: "none"
    },
    "&::placeholder": {
      color: theme.base.color.text.body.secondary
    },
    "&:not(:disabled):hover": {
      background: hasValue ? theme.base.color.translucent.emphasis[300] : theme.base.color.translucent.emphasis[200],
      boxShadow: validationStatus === "error" ? "".concat(hoverShadow, ", inset 0 0 0 ").concat(theme.base.border.size[100], " ").concat(theme.base.color.status.fatal.bright) : "".concat(hoverShadow, ", inset 0 0 0 ").concat(theme.base.border.size[100], " ").concat(theme.base.color.translucent.standard[800])
    },
    "&:not(:disabled):focus": {
      outline: "none",
      background: theme.base.color.translucent.emphasis[300],
      boxShadow: validationStatus === "error" ? "".concat(focusShadow, ", inset 0 0 0 ").concat(theme.base.border.size[200], " ").concat(theme.base.color.status.fatal.bright) : "".concat(focusShadow, ", inset 0 0 0 ").concat(theme.base.border.size[200], " ").concat(theme.base.color.translucent.standard[1000])
    }
  };
}
var renderResponsiveInputSx = function renderResponsiveInputSx(props) {
  return getResponsiveSx(_objectSpread(_objectSpread({}, props), {}, {
    renderSxAtSize: renderInputSx
  }));
};
function renderContainerStyles(_ref3) {
  var size = _ref3.size,
    theme = _ref3.theme;
  switch (size) {
    case "large":
      return {
        height: theme.base.spacing.x16
      };
    case "medium":
    default:
      return {
        height: theme.base.spacing.x12
      };
  }
}
var renderResponsiveContainerStyles = function renderResponsiveContainerStyles(props) {
  var sx = getResponsiveSx(_objectSpread(_objectSpread({}, props), {}, {
    renderSxAtSize: renderContainerStyles
  }));
  return sx;
};

export { adornmentSx as a, renderContainerStyles as b, inputContainerBaseSx as c, renderResponsiveInputSx as d, renderInputSx as e, baseInputSx as f, clearValueButtonSx as g, rightButtonsContainerSx as h, inputIconBaseSx as i, leftContainerSx as l, renderResponsiveContainerStyles as r, sideContainerSx as s };
//# sourceMappingURL=styles2.js.map
